import type { IGrowthOverviewTableRow } from "../types";

export const isGrowthOverviewRowExpandable = (row: IGrowthOverviewTableRow): boolean => {
    if (row.rowType === "domain") {
        return false;
    }

    if ((row.children?.length ?? 0) > 0) {
        return true;
    }

    if (row.rowType === "industry") {
        return true;
    }

    return (row.domainCount ?? 0) > 0;
};
